/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import dipyramidUrl from '../../../assets/gems/dipyramid.svg?inline';
export function Dipyramid({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: dipyramidUrl,
        alt: "DipyramidImage"
    });
}
